const locales = {
  chat_usersConnected: 'Show Online Only',
  chat_newChat: "New Chat",
  search_user: "Search by Driver, User...",
  user_filter: "Filter",
  online_only: "Online Only",
  show_users: "Show Users",
  show_drivers: "Show Drivers",
  empty_text: "Nothing to show here yet.",
  chat_lastMessage: "Last Message  ",
  MASTERUSER: 'User',
  SUBUSER: 'User',
  DRIVER: 'Driver',
  chat_onlineStatus: "Online",
  chat_offlineStatus: "Offline",
  chat_writingStatus: "Writing...",
  chat_messageStatus: "Read",
  chat_modalTitle: "Chats",

  ai_title: 'Neurion AI (BETA)',
  ai_defaultMessage: "Hello! How can I help you?",
  agent_question_placeholder: 'Ask me about the GPS Trackit platform...',
  agent_send: 'Send',
  agent_thinking: 'Searching the GPS Trackit platform knowledge base...',
  agent_sending: 'Searching...',
  agent_error: 'Sorry, I encountered an error. Please try again.',
  agent_welcome: 'Hello! I\'m your AI assistant. How can I help you with your fleet management today?',
  agent_response_template: 'For your question: "{question}", here\'s how you can do that. This involves several steps in the settings panel.',
  agent_action_show_how: 'Would you like me to show you how to do that?',
  agent_action_show_where: 'Would you like me to show you where that is?',
  header_agentIcon: 'zonAI',
  header_agentIconAriaLabel: 'Open zonAI Assistant',

  support_title: "Customer Support Chat",
  support_chat_title: "Support Chat",
  support_defaultMessage: "Start a new support chat",
  
  // Support Chat - Connection Status
  support_status_offline: "Offline",
  support_status_initializing: "Initializing...",
  support_status_connecting: "Connecting to support...",
  support_status_waiting_agent: "Finding an available agent...",
  support_status_connected: "Connected",
  support_status_reconnecting: "Reconnecting...",
  support_status_agent_unavailable: "All agents are currently unavailable",
  support_status_ended: "Conversation ended",
  support_status_error: "Connection error",
  
  // Support Chat - Input Placeholders
  support_input_initializing: "Initializing...",
  support_input_connecting: "Connecting to support...",
  support_input_waiting: "Waiting for an agent to join...",
  support_input_unavailable: "No agents available at the moment",
  support_input_ended: "Conversation has ended",
  support_input_error: "Connection error - chat unavailable",
  support_input_unavailable_default: "Chat unavailable",
  
  // Support Chat - Wait Screen
  support_wait_message: "We're finding the best person to help you. We'll be right with you.",
  support_wait_finishing_title: "Finding the best person to help you",
  support_wait_finishing_message: "We're connecting you with the right agent for your request. This usually takes just a moment — thanks for your patience!",
  support_cancel_request: "Cancel request",
  support_unavailable_title: "Our agents are still finishing up other chats",
  support_unavailable_message_before: "It's taking a bit longer than usual. You can keep waiting here, or ",
  support_unavailable_message_after: " — we'll reply as soon as someone's free.",
  support_unavailable_email_link: "send us an email",
  support_no_agents_title: "Sorry, we couldn't connect you right now.",
  support_no_agents_message_before: "We couldn't find an available agent at the moment. However, feel free to ",
  support_no_agents_message_after: ", and we'll get back to you as soon as we can.",
  support_start_new_chat: "Start a new Support Chat",
  support_agent_default_name: "Support Agent",
  support_started_message: "from Zonar has joined the chat",
  support_ended_message_before: "from Zonar has left the chat",
  support_ended_message: "The conversation has ended. Close and reopen the chat to start a new conversation.",
  support_agent_typing: "Support agent is typing...",
  support_network_error: "Network Connection Issue - Please try again later",

  last_day: "Last",
  message_Sent: "Sent",
  message_Read: "Read",
  chat_startNewConversation: "Start a new conversation",
  chat_startedAt: "Chat started at",
  chat_startedOn: "Chat started on",

  // AI Welcome Message
  ai_welcome_greeting: `Hello! I'm **Neurion** 👋`,
  ai_welcome_description: `I'm here to help you get the most out of our platform. You can ask me questions about how to use features, where to find things, or for tips and best practices.`,
  ai_welcome_cta: `What can I help you with today?`,

  agent_stage_IDLE: `Idle`,
  agent_stage_ANALYZING: `Analyzing your request...`,
  agent_stage_CONNECTING_KB_AGENT: `Connecting to the knowledge base agent...`,
  agent_stage_RETRIEVING: `Searching for relevant matches...`,
  agent_stage_GENERATING: `Generating`,
  agent_stage_COMPLETE: `Complete`,
  agent_stage_ERROR: `Something went wrong — please try again shortly.`,
  agent_stage_RATE_LIMIT_EXCEEDED: `You've reached your daily limit of messages. Please reach out to customer service to increase your plan limits.`,
  agent_stage_try_again: `try again`,
  agent_stage_INPUT_VALIDATION_ERROR: `We encountered a technical issue and couldn't process your request. Please reach out to support for assistance.`,
  agent_stage_SCHEMA_VALIDATION_ERROR: `We encountered a technical issue and couldn't process your request. Please reach out to support for assistance.`,

  // AI Connection Status
  ai_status_connecting: "Connecting...",
  ai_status_connection_lost: "Connection lost...",

  // AI Suggestions
  ai_suggestions_intro: "Hey! I'm doing great. How can I help you? Here are a few of the most common questions I can help you with:",

};

export default locales;
